import type { MessageDescriptor } from 'react-intl';

import { standardMessages } from '../../ui/modal/messages';

function isMessageDescriptor(value: unknown): value is MessageDescriptor {
	return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}

/**
 * Default strings for standard-benefits copy until Traduki publishes matching keys in
 * `@atlassian/afm-i18n-platform-growth-edition-benefits-modal`. Merged into Intl defaultMessages.
 */
export const standardBenefitsFallbackMessages: Record<string, string> = Object.fromEntries(
	Object.values(standardMessages)
		.filter(isMessageDescriptor)
		.map((d) => {
			const msg = d.defaultMessage;
			return [d.id, typeof msg === 'string' ? msg : String(msg)];
		}),
);
